import type { Components } from '@mui/material/styles/components';
import type { Theme } from '@mui/material/styles/createTheme';

export const MuiToggleButton: Components<Theme>['MuiToggleButton'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '&.Mui-disabled': {
        color: theme.palette.common.white,
      },
    }),
  },
};
